import React from "react";

/** Results card header: keyword search with the result count inside the field on the right. */
function PortalResultsHead({
  heading,
  count,
  keyword,
  onKeywordChange,
  placeholder = "Keyword search",
  ariaLabel,
}) {
  const totalLabel = `${heading}: ${count}`;

  return (
    <div className="cportal-card-head cportal-leads-results-head">
      <div className="cportal-results-title">
        <h3>Results</h3>
        <span className="cportal-results-pill" aria-label={totalLabel}>
          {count}
        </span>
      </div>
      <div className="cportal-leads-results-tools">
        <span className="cportal-muted cportal-results-total cportal-results-total--external">
          {totalLabel}
        </span>
        <div className="cportal-results-search-wrap">
          <input
            className="cportal-search cportal-results-search"
            type="text"
            placeholder={placeholder}
            value={keyword}
            onChange={(e) => onKeywordChange(e.target.value)}
            aria-label={ariaLabel || `Keyword search ${heading}`}
          />
          <span
            className="cportal-results-total cportal-results-total--in-field"
            title={totalLabel}
            aria-label={totalLabel}
          >
            {count}
          </span>
        </div>
      </div>
    </div>
  );
}

export default PortalResultsHead;
